import React from 'react'

export default function Contact() {
    return (<>
        <div className="container" style={{ minHeight: '90vh' }}>
            <div className="row" style={{ minHeight: '90vh' }}>
                <div className="div d-flex justify-content-center align-items-center flex-column">
                    <div className="border p-3 rounded-3">
                        <div className='fs-4 p-2'>Developed By : Mohamed Saber</div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
